const loading = ref<boolean>(false);

export const useLoading = () => {
  return {
    show: () => {
      loading.value = true;
    },
    hide: () => {
      loading.value = false;
    },
    loading,
  };
};
